import { useStaticQuery, graphql } from "gatsby"

const usePostsQuery = () => {
  return useStaticQuery(graphql`
    query PostsQuery {
      posts: allWpPost(
        filter: {categories: {nodes: {elemMatch: {slug: {ne: "hivemind"}}}}},
        sort: {date: DESC}
      ) {
        nodes {
          ...ArticleCard
        }
      }
      categories: allWpCategory(
        filter: {
          count: {ne: null}
          slug: {nin: ["uncategorized", "hivemind"]}
        }
      ) {
        nodes {
          name
          slug
        }
      }
    }
  `)
}

export default usePostsQuery